import React from 'react';
import PropTypes from 'prop-types';

import ExperienceDatesFromContainer from 'src/app/containers/Registration/Experience/ExperienceDatesFromContainer';
import ExperienceDatesToContainer from 'src/app/containers/Registration/Experience/ExperienceDatesToContainer';
import 'src/app/containers/Registration/Experience/ExperienceDatesComponent.scss';


class ExperienceDatesComponent extends React.PureComponent {
  render() {
    const { dateFromInputRef, dateToInputRef } = this.props;
    return (
      <div styleName="experience-dates">

        <div styleName="experience-dates__title">
          Okres
        </div>

        <div styleName="experience-dates__inputs inputs">

          <div styleName="inputs__date-from">
            <ExperienceDatesFromContainer inputRef={ dateFromInputRef } { ...{ dateToInputRef } }/>
          </div>

          <div className="inputs__date-to">
            <ExperienceDatesToContainer inputRef={ dateToInputRef }  dateFromInputRef={ dateFromInputRef }/>
          </div>

        </div>

      </div>
    );
  }
}

ExperienceDatesComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  dateFromInputRef: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dateToInputRef: PropTypes.object.isRequired
};

export default ExperienceDatesComponent;
